Q   = require('q')
Vue = require('vue/dist/vue')

module.exports =
  namespaced: true

  state:

    partners: []

  mutations:

    _setPartners: (state, payload) ->
      Vue.set state, 'partners', payload.partners

  actions:

    load: (context) ->
      d = Q.defer()

      axiosData =
        method: 'get'
        url:    '/api/partners'

      context.dispatch('net/call', axiosData, { root: true })
      .then (responseData) ->
        context.commit('_setPartners', { partners: responseData.data?.data || [] })
        d.resolve(partners: responseData.data?.data || [])
      .done()

      d.promise


// WEBPACK FOOTER //
// ./assets/js/frontend/store/partners/index.coffee